import React from 'react';
import compose from 'recompose/compose';
import Card from '@material-ui/core/Card';
import MapIcon from '@material-ui/icons/LocationOn';
import Map from './Map';
import { withStyles } from '@material-ui/core/styles';
import { translate } from 'react-admin';

import CardIcon from './CardIcon';

const styles = {
    main: {
        flex: '1',
        marginRight: '1em',
        marginTop: 20,
    },
    card: {
        overflow: 'inherit',
        textAlign: 'right',
        padding: 16,
        minHeight: 52,
    },
};

const WssMap = ({ selectedDevice, classes }) => (
    <div className={classes.main}>
        <CardIcon Icon={MapIcon} bgColor={"green"} />
        <Card className={classes.card}>
            <Map selectedDevice={selectedDevice} />
        </Card>
    </div>
);

const enhance = compose(
    withStyles(styles),
    translate
);

export default enhance(WssMap);